module.exports = __webpack_public_path__ + "static/media/polytechnic-campus.63c8415c.jpg";